import { classSet } from '@platform/ui-library';
import { FC } from 'react';
import { KeyCode } from '@app/const';
import { FormControlProps } from '@app/types';
import { ControlWithFormField, FormFieldControlProps } from './form-field';
import styles from './Switch.module.scss';

export type SwitchControlProps = (
  FormControlProps<boolean>
  & {
    className?: string;
    /** @deprecated Display a warning/error on user interaction instead of disabling inputs. */
    disabled?: boolean;
    name?: string;
  }
);

export const SwitchControl: FC<SwitchControlProps> = ({
  className,
  onChange,
  value,
  ...props
}) => {
  return (
    <input
      {...props}
      checked={value ?? undefined}
      className={classSet([styles.switch, className])}
      onKeyDown={(event) => {
        if (
          event.code === KeyCode.enter
          || event.code === KeyCode.space
          || (event.ctrlKey && event.code === KeyCode.y)
        ) {
          event.preventDefault();
          onChange(!value);
        }
      }}
      onChange={(e) => onChange(e.target.checked)}
      type="checkbox"
    />
  );
};

export type SwitchProps = SwitchControlProps & FormFieldControlProps;

export const Switch: FC<SwitchProps> = (props) => {
  return (
    <ControlWithFormField control={SwitchControl} {...props} />
  );
};
